import { useQuery } from '@hooks/reactQuery';

import { getOptionsKpiLineType } from '@api/kpi';

import { extractQueryParams } from '@utils/common';

import { IOptionsKpiDto } from '@interfaces/kpi/dto/kpiDTO';

import { EUserRoles, TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';

export const useQueryOptionsKpiLineType = ({ isKpiView, vendor, queryKey, availableVendors }: {
	isKpiView: boolean;
	vendor: TVendorsValues;
	queryKey: string;
	availableVendors: string[];
}): {
	optionsKpi?: IOptionsKpiDto[];
	isLoadingOptionsKpi: boolean;
} => {
	const isEnabledByVendor = availableVendors.includes(vendor);

	const {
		data: optionsKpi,
		isInitialLoading: isLoadingOptionsKpi,
	} = useQuery({
		queryKey: [queryKey, vendor],
		queryFn: extractQueryParams(getOptionsKpiLineType),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isEnabledByVendor],
		...refetchOptions,
	});

	return {
		optionsKpi,
		isLoadingOptionsKpi,
	};
};
